import { sessionService } from "./index";
import { Endpoints, HttpService } from "@/api";
import { SessionServiceInterface } from "./SessionService";

export const cardErrorMessage: Record<string, string> = {
  invalid_expiry_month: "Mês de vencimento do cartão inválido",
  invalid_expiry_year: "Ano de vencimento do cartão inválido",
  invalid_cvc: "Código de segurança do cartão inválido",
  incorrect_number: "Número do cartão inválido",
};

export class PaymentService {
  constructor(
    private readonly http: HttpService,
    private readonly sessionService: SessionServiceInterface
  ) {}

  ERROR_TOKENS = {
    generic_reason: "tok_visa_chargeDeclined",
    insufficient_founds: "tok_visa_chargeDeclinedInsufficientFunds",
    lost_card: "tok_visa_chargeDeclinedLostCard",
    stolen_card: "tok_visa_chargeDeclinedStolenCard",
    expired_card: "tok_chargeDeclinedExpiredCard",
    incorrect_cvv: "tok_chargeDeclinedIncorrectCvc",
    processing_error: "tok_chargeDeclinedProcessingError",
  };

  async getCreditCards() {
    const session = sessionService.getSession();

    const { data } = await this.http.get<any>(Endpoints.cards);

    const cards = data.map((elem: any) => ({
      card_id: elem.id,
      last_digits: elem.card.last4,
    }));

    const currentCardId = session?.favorite_card?.card_id;

    let newFavoriteCard = null;
    if (cards.length) {
      newFavoriteCard = currentCardId
        ? cards.find((elem: any) => elem.card_id == currentCardId)
        : cards[0];
    }
    this.setFavoriteCard(newFavoriteCard);
    return { status: true, data: cards, favorite_card: newFavoriteCard };
  }

  createCreditCard(card_hash: string) {
    return this.http.post(Endpoints.cards, { card_hash });
  }

  setFavoriteCard(card: any) {
    const session = sessionService.getSession();
    if (session) {
      this.sessionService.updateSession({ favorite_card: card });
    }
  }

  removeCard(card_id: string | number) {
    return this.http.delete(`${Endpoints.cards}?card_id=${card_id}`);
  }
}
